export default {
      id: "ar_nouvel_arrivant-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ar_nouvel_arrivant-usage",
      toString: function () {
        return this.url;
      }
    }